"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const x_data_grid_1 = require("@mui/x-data-grid");
const SimpleButton_1 = require("../../atoms/SimpleButton/SimpleButton");
const styled_1 = __importDefault(require("@emotion/styled"));
const icons_material_1 = require("@mui/icons-material");
const ActionButtonsContainer = styled_1.default.div `
  display: flex;
  gap: 16px;
`;
const Grid = (props) => {
    var _a;
    const heightGrid = `${props.heightGrid || 300}px`;
    const actionButtonsLength = ((_a = props.actionButtons) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const finalLength = actionButtonsLength > 3 ? 1 : actionButtonsLength;
    const Container = styled_1.default.div `
    display: flex;
    min-width: 700px;
    width: 100%;
    height: ${heightGrid};
  `;
    let columnsToDisplay = [];
    // Add favorite icon column before all the columns
    if (props.showFavoriteButton) {
        columnsToDisplay = [
            {
                field: 'favorite',
                renderCell: () => {
                    return ((0, jsx_runtime_1.jsx)(ActionButtonsContainer, { children: (0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, { "data-testid": "favorite-button", size: "medium", variant: "favorite" }) }));
                },
                renderHeader: () => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
                width: 10,
            },
        ];
    }
    // Add all the columns
    props.columns.forEach((column) => columnsToDisplay.push(column));
    // Add the actionButtons at end of grid
    if (actionButtonsLength) {
        columnsToDisplay = columnsToDisplay.concat([
            {
                field: 'actions',
                // For each button variant in actionButtons, display the corresponding button
                renderCell: () => {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(ActionButtonsContainer, { children: actionButtonsLength > 3 ? ((0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ size: "small", variant: "icon-secondary-dark-blue", onClick: () => console.log('More option clicked') }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.MoreVert, {}) }))) : ((_a = props.actionButtons) === null || _a === void 0 ? void 0 : _a.map((button, index) => {
                            return ((0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ size: "small", variant: button.variant, onClick: () => button.action() }, { children: button.icon }), index));
                        })) }));
                },
                // Do not display column name for action buttons
                renderHeader: () => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
                // Set 50px width for each button
                width: finalLength * 50,
            },
        ]);
    }
    // Get className to style rows
    const getRowClassName = (params) => {
        let className = '';
        if (props.showRowBackground) {
            className += 'with-background';
        }
        if (props.showRowLeftThickBorder) {
            switch (params.row.status) {
                case 'OK':
                    className += ' status-ok';
                    break;
                case 'KO':
                    className += ' status-ko';
                    break;
                case 'EXPIRE':
                    className += ' status-expire';
                    break;
                default:
                    className += ' status-basic';
                    break;
            }
        }
        return className;
    };
    // Get className to style cells
    const getCellClassName = (params) => {
        if (params.field === 'status') {
            switch (params.formattedValue) {
                case 'OK':
                    return 'status-ok';
                case 'KO':
                    return 'status-ko';
                case 'EXPIRE':
                    return 'status-expire';
                default:
                    return '';
            }
        }
        else
            return typeof params.formattedValue === 'number' ? 'quantity' : '';
    };
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({ "data-testid": "grid" }, { children: (0, jsx_runtime_1.jsx)(x_data_grid_1.DataGrid, Object.assign({}, props, { 
            // Spacing of 8px between rows, but not for the first and last one
            getRowSpacing: (params) => ({
                top: 0,
                bottom: params.isLastVisible || !props.showRowBackground ? 0 : 8,
            }), 
            // Show thick left row border if showRowLeftThickBorder is true
            getRowClassName: getRowClassName, getCellClassName: getCellClassName, columns: columnsToDisplay.map((column) => (Object.assign(Object.assign({}, column), { headerAlign: 'center', align: 'center', headerClassName: props.showRowLeftThickBorder ? 'with-status' : '' }))), rows: props.rows })) })));
};
exports.Grid = Grid;
